export default "__VITE_ASSET__cCkO3HSG__"